import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Prepend backend URL for server-hosted images (e.g. AI-generated wolfdog PNGs).
export const asset = (path) => {
  if (!path) return path;
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) return path;
  if (path.startsWith("/")) return `${BACKEND_URL}${path}`;
  return path;
};

// AI-generated wolfdog imagery — served from the backend via /api/img/*.png
export const IMG = {
  hero: asset("/api/img/hero_wolfdog.png"),
  puppies: asset("/api/img/puppies_lineup.png"),
  puppy: asset("/api/img/puppy_portrait.png"),
  packSnow: asset("/api/img/pack_snow.png"),
  forest: asset("/api/img/wolfdog_forest.png"),
  howl: asset("/api/img/wolfdog_howl.png"),
  grass: asset("/api/img/wolfdog_grass.png"),
  closeup: asset("/api/img/wolfdog_closeup.png"),
  community: asset("/api/img/community_pack.png"),
  family: asset("/api/img/wolfdog_family.png"),
};

// AI-generated Sora 2 hero video — webm (Chromium/Firefox) + mp4 (Safari) fallbacks
export const HERO_VIDEO_WEBM = asset("/api/video/hero_loop.webm");
export const HERO_VIDEO_MP4 = asset("/api/video/hero_loop.mp4");
